export default {
  mounted() {
    this.triggerPageEvent();
  },
  methods: {
    triggerPageEvent() {
      setTimeout(() => {
        this.$analytics.page(this.pageName);
      }, 2000);
    },
  },
};



// WEBPACK FOOTER //
// ./app/src/shared/pageMixin.js